/**
 * Profile media service for @ollaid/native-sso
 * Uploads the cropped avatar to the IAM authenticated profile endpoint.
 *
 * @version 2.7.9
 */

import { fetchWithTimeout, getAuthToken, getHeaders, getIamApiBaseUrl, ensureDeviceContext } from './api';
import type { UserInfos } from '../types/native';

export interface ProfileImageUploadResponse {
  message?: string;
  user?: UserInfos;
  user_infos?: UserInfos;
}

export const profileMediaService = {
  async uploadProfileImage(image: Blob, filename = 'avatar.jpg'): Promise<ProfileImageUploadResponse> {
    const baseUrl = getIamApiBaseUrl();
    const token = getAuthToken();
    if (!token) {
      throw new Error('Token manquant');
    }

    await ensureDeviceContext();

    const formData = new FormData();
    formData.append('image', image, filename);

    const headers = getHeaders(token, false);
    delete (headers as Record<string, string>)['Content-Type'];

    return fetchWithTimeout<ProfileImageUploadResponse>(
      `${baseUrl}/backoffice/profile/image`,
      {
        method: 'POST',
        headers,
        body: formData,
      },
      30000
    );
  },
};

export default profileMediaService;
